"use client";
import { useState, useEffect } from "react";
import { Menu, X, ShoppingCart, Home, Folder, User, Box } from "lucide-react";
import Link from "next/link";
import UserMenu from "./UserMenu";
import Image from "next/image";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [islogin] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1020);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {!isMobile && (
        <nav className="bg-gray-300 shadow-md p-5 sticky top-0 z-50 bg-opacity-70 backdrop-blur-md">
          <div className="container mx-auto flex justify-between items-center">
            <div className="text-xl gap-4 font-bold text-gray-800 flex items-center">
              <Image
                src="/pwa-512x512.svg"
                width={60}
                height={60}
                alt="ShopLogo"
                className="w-10 h-10"
              />
              <p>آدینا رایانه</p>
            </div>
            <ul className="hidden lg:flex items-center gap-20 text-gray-700">
              <li>
                <Link
                  href="/"
                  className="flex items-center gap-2 hover:text-blue-600"
                >
                  <Home className="w-5 h-5" />
                  خانه
                </Link>
              </li>
              <li>
                <Link
                  href="/products"
                  className="flex items-center gap-2 hover:text-blue-600"
                >
                  <Box className="w-5 h-5" />
                  محصولات
                </Link>
              </li>
              <li>
                <Link
                  href="/contact"
                  className="flex items-center gap-2 hover:text-blue-600"
                >
                  <Folder className="w-5 h-5" />
                  تخفیفات شگفت انگیز
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-4">
              <Link href={"/search"}>
                <button className="relative bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full flex items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                    />
                  </svg>
                </button>
              </Link>

              <Link href="/cart">
                <button className="hidden lg:flex relative bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full">
                  <ShoppingCart className="w-5 h-5" />
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-1 rounded-full">
                    3
                  </span>
                </button>
              </Link>
              {islogin ? (
                <>
                  <Link
                    href="/login"
                    className="hidden lg:flex relative bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
                  >
                    ثبت نام | ورود
                  </Link>
                </>
              ) : (
                <UserMenu />
              )}
              <button className="lg:hidden" onClick={() => setIsOpen(!isOpen)}>
                {isOpen ? (
                  <X className="w-6 h-6" />
                ) : (
                  <Menu className="w-6 h-6" />
                )}
              </button>
            </div>
          </div>

          {isOpen && (
            <div className="md:hidden bg-white shadow-md p-4 absolute w-full left-0 top-full">
              <ul className="flex flex-col space-y-4 text-gray-700">
                {!islogin ? (
                  <li className="hover:text-blue-600 cursor-pointer">
                    ثبت نام و ورود
                  </li>
                ) : (
                  <li className="hover:text-blue-600 cursor-pointer">
                    پروفایل
                  </li>
                )}
                <li className="hover:text-blue-600 cursor-pointer">سبد خرید</li>
                <li className="hover:text-blue-600 cursor-pointer">
                  دسته بندی
                </li>
                <li className="hover:text-blue-600 cursor-pointer">
                  درباره ما
                </li>
                {/* <Link href='/cart'>
              </Link> */}
              </ul>
            </div>
          )}
        </nav>
      )}

      {isMobile && (
        <>
          <nav className="bg-gray-300 shadow-md p-5 sticky top-0 z-50 bg-opacity-70 backdrop-blur-md">
            <div className="container mx-auto flex justify-between items-center">
              <div className="text-xl gap-4 font-bold text-gray-800 flex items-center">
                <Image
                  src="/pwa-512x512.svg"
                  width={60}
                  height={60}
                  alt="ShopLogo"
                  className="w-10 h-10"
                />
              </div>
              
              <div className="flex items-center gap-4">
                <Link href={"/search"}>
                  <button className="relative bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                      />
                    </svg>
                  </button>
                </Link>

                <Link href="/cart">
                  <button className="hidden lg:flex relative bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full">
                    <ShoppingCart className="w-5 h-5" />
                    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-1 rounded-full">
                      3
                    </span>
                  </button>
                </Link>
                {islogin ? (
                  <>
                    <Link
                      href="/login"
                      className="hidden lg:flex relative bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
                    >
                      ثبت نام | ورود
                    </Link>
                  </>
                ) : (
                  <UserMenu />
                )}
                <button
                  className="lg:hidden"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  {isOpen ? (
                    <X className="w-6 h-6" />
                  ) : (
                    <Menu className="w-6 h-6" />
                  )}
                </button>
              </div>
            </div>

            {isOpen && (
              <div className="md:hidden bg-white shadow-md p-4 absolute w-full left-0 top-full">
                <ul className="flex flex-col space-y-4 text-gray-700">
                  {!islogin ? (
                    <li className="hover:text-blue-600 cursor-pointer">
                      ثبت نام و ورود
                    </li>
                  ) : (
                    <li className="hover:text-blue-600 cursor-pointer">
                      پروفایل
                    </li>
                  )}
                  <li className="hover:text-blue-600 cursor-pointer">
                    سبد خرید
                  </li>
                  <li className="hover:text-blue-600 cursor-pointer">
                    دسته بندی
                  </li>
                  <li className="hover:text-blue-600 cursor-pointer">
                    درباره ما
                  </li>
                  {/* <Link href='/cart'>
              </Link> */}
                </ul>
              </div>
            )}
          </nav>

          <div className="fixed bottom-0 left-0 w-full bg-white shadow-md border-t flex justify-around py-3 z-50">
            <button className="flex flex-col items-center text-gray-700 hover:text-blue-600">
              <Home className="w-6 h-6" />
              <span>خانه</span>
            </button>
            <button className="flex flex-col items-center text-gray-700 hover:text-blue-600">
              <Box className="w-6 h-6" />
              <span>محصولات</span>
            </button>
            <button className="flex flex-col items-center text-gray-700 hover:text-blue-600">
              <Folder className="w-6 h-6" />
              <span>سبد خرید </span>
            </button>
            <button className="flex flex-col items-center text-gray-700 hover:text-blue-600">
              <Link href="/profile">
                <User className="w-6 h-6" />
                <span> پروفایل</span>
              </Link>
            </button>

            {/* 
          <button className="flex flex-col items-center text-gray-700 hover:text-blue-600" >
            <Link href={"/cart"}>
            <ShoppingCart className="w-6 h-6" />
            <span>سبد خرید</span>
            </Link>
          </button> */}
          </div>
        </>
      )}
    </>
  );
};

export default Navbar;
